import { Check } from 'lucide-react'
import { Button } from '@/components/shared/atoms/Button'
import { Drawer } from '@/components/shared/Drawer'
import { CURRENCIES } from '@/constants/currencies'

export const CurrenciesBottomSheet = ({
    open,
    setOpen,
    currency,
    setCurrency,
}: {
    open: boolean
    setOpen: (open: boolean) => void
    currency: string
    setCurrency: (currency: string) => void
}) => {
    const handleClose = () => {
        setOpen(false)
    }
    return (
        <Drawer
            triggerContent={null}
            open={open}
            onOpenChange={handleClose}
            contentClassName="!z-[50]"
        >
            <section className="relative mx-auto max-w-md px-2 md:max-w-4xl">
                <div className="pb-4">
                    {CURRENCIES.map((curr) => (
                        <div
                            onClick={() => {
                                setCurrency(curr.code)
                            }}
                            key={curr.code}
                            className="flex items-center justify-between border-b border-[#f0f0f0] px-2 py-4"
                        >
                            <p className="flex items-center gap-3 text-sm font-semibold text-black">
                                {curr.code === 'ORIGINAL' ? (
                                    <span>Original Currency</span>
                                ) : (
                                    <>
                                        <span>{curr.symbol}</span>
                                        {curr.code}
                                    </>
                                )}
                            </p>
                            {currency === curr.code && (
                                <Check color="#333333" width={20} height={20} />
                            )}
                        </div>
                    ))}
                </div>
                <div className="mb-4 w-full bg-white">
                    <Button
                        onClick={handleClose}
                        fullWidth
                        variant="outline"
                        className="bg-white"
                    >
                        Close
                    </Button>
                </div>
            </section>
        </Drawer>
    )
}
